import { useCallback } from "react";

import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { activationTracking } from "app/pages/activation/services/tracking";
import type { ActionableInsight } from "app/pages/activation/types/api";

import { buildInsightCopyPlainText } from "../helpers/buildInsightCopyPlainText";
import * as SC from "../styles";
import { INSIGHTS_FEEDBACK_THUMBS_UP } from "../texts";

type InsightFeedbackThumbsUpButtonProps = {
    isActive: boolean;
    onActiveChange: (active: boolean) => void;
    onClearDislike: () => void;
    dataAutomation: string;
    insight: ActionableInsight;
};

export const InsightFeedbackThumbsUpButton = ({
    isActive,
    onActiveChange,
    onClearDislike,
    dataAutomation,
    insight,
}: InsightFeedbackThumbsUpButtonProps) => {
    const tracking = activationTracking.homePageInsights;

    const handleClick = useCallback(() => {
        const nextLiked = !isActive;

        onActiveChange(nextLiked);

        if (nextLiked) {
            tracking.trackInsightThumbsUp(buildInsightCopyPlainText(insight));

            onClearDislike();
        }
    }, [insight, isActive, onActiveChange, onClearDislike, tracking]);

    return (
        <Tooltip
            content={translate(INSIGHTS_FEEDBACK_THUMBS_UP)}
            placement="bottom"
        >
            <SC.StyledIconButton
                type="flat"
                iconName={isActive ? "thumb-up" : "thumb-up-outline"}
                iconSize="xs"
                dataAutomation={dataAutomation}
                onClick={handleClick}
            />
        </Tooltip>
    );
};
